import React, { useContext, useMemo } from "react";

import FeesTemplateContext from "../feesTemplateContext";
import TemplateField from "../templateField";

type FeesAriseFieldProps = {
	fee: {
		name: string;
		displayName: string;
		sign?: string;
	};
	showRequiredMark?: boolean;
};

const FeesAriseField = ({
	fee,
	showRequiredMark = false,
}: FeesAriseFieldProps) => {
	const {
		validators,
		application: { isPaperApplication },
	} = useContext(FeesTemplateContext);

	const { ariseFeeCurrency } = validators;

	const placeholderClassName = useMemo(
		() =>
			isPaperApplication ? "placeholder-value" : "placeholder-primary",
		[isPaperApplication],
	);

	return (
		<TemplateField
			name={fee?.name}
			label={`${fee?.displayName},\u00A0$`}
			sign={fee?.sign}
			placeholder="0.000000"
			placeholderClassName={placeholderClassName}
			validators={ariseFeeCurrency?.validators}
			normalize={ariseFeeCurrency?.normalize}
			normalizeOnBlur={ariseFeeCurrency?.normalizeOnBlur}
			hideRequiredMark={!showRequiredMark}
			wrapperClassName="align-items-center"
		/>
	);
};

export default FeesAriseField;
